import { tns } from "tiny-slider/src/tiny-slider"

export class SliderComponent {
    constructor(selector, config) {
      if(document.querySelector(selector)) {
        const settings = {
          320: {
            items: 1.1
          },
          500: {
            items: 3.5
          }
        };

        let slider = tns({
          container: document.querySelector(selector),
          slideBy: 'page',
          mouseDrag: true,
          loop: false,
          responsive: (config) ? config : settings,
          controlsText: ['<', '>'],
          controlsPosition: "bottom",
          navPosition: "bottom"
        });
      }
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/slider/slider.component.js